import { render, staticRenderFns } from "./LenderRatings.vue?vue&type=template&id=48437286&scoped=true&"
import script from "./LenderRatings.vue?vue&type=script&lang=js&"
export * from "./LenderRatings.vue?vue&type=script&lang=js&"
import style0 from "./LenderRatings.vue?vue&type=style&index=0&id=48437286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48437286",
  null
  
)

export default component.exports